import { Alt1GLFrameStream } from "./Alt1GLFrameStream";
import { lazy } from "../../Lazy";
import { BufferCache } from "../alt1gllib/ts/programs/filteredstate";
import { getProgramMeta } from "../alt1gllib/ts/render/renderprogram";
import { Alt1 } from "../Alt1";
export class Alt1GLCapturedFrame {
    constructor(options, renders) {
        this.options = options;
        this.frame_number = renders?.[0]?.framenr;
        this.renders = renders.map(r => new Alt1GLCapturedFrame.Render(r));
    }
    static async capture(options = { features: ["full"] }) {
        const renders = await Alt1.instance().opengl().get().recordRenderCalls(options);
        return new Alt1GLCapturedFrame(options, renders);
    }
    static subscribe(options, handler) {
        return new Alt1GLFrameStream(Alt1.instance().opengl().get().streamRenderCalls(options, renders => {
            console.log(`captured ${renders.length} renders`);
            handler(new Alt1GLCapturedFrame(options, renders));
            // Immediately detach from renders invocations instead of waiting for them being garbage collected.
            renders.forEach(r => r.detach());
        }));
    }
}
(function (Alt1GLCapturedFrame) {
    const buffer = lazy(() => new BufferCache(null));
    class Render {
        constructor(raw) {
            this.raw = raw;
            this.mesh = lazy(() => buffer.get().getMeshData(this.raw));
            this.progmeta = lazy(() => getProgramMeta(this.raw.program));
        }
    }
    Alt1GLCapturedFrame.Render = Render;
})(Alt1GLCapturedFrame || (Alt1GLCapturedFrame = {}));
